<!-- <formio-loader></formio-loader> -->

<div class="app-resource-autocomplete-wrapper">
  <div class="d-flex">
    <label class="control-label {{required ? 'field-required' : ''}}">
      {{'forms.common.' + customOptions?.label | translate}}
    </label>
    <span *ngIf="labelHint?.label" class="{{labelHint?.cssClass}}">
      <ng-container *ngIf="labelHint.translatable;else showLabel">
        <span class="hintTitle">{{'forms.common.' + labelHint.label | translate}}</span>
      </ng-container>
      <ng-template #showLabel>
        <span class="hintTitle">{{labelHint.label}}</span>
      </ng-template>
    </span>
  </div>

  <ng-container *ngIf="formioComponent?.options?.viewAsHtml;else showInput">
    <dd>{{filterControl.value}}</dd>
  </ng-container>
  <ng-template #showInput>
    <mat-form-field>
      <input type="text" matInput class="form-control" [formControl]="filterControl" [matAutocomplete]="auto"
        (click)="openAutocomplete()">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayAs">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
          class="mat-option {{ option | cssClassDisplay : customOptions.optionClass }}">
          {{ option | evaluationDisplay : customOptions.displayField }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-template>

</div>
<!--



 -->